import './Documents.scss'

import {Component} from 'react'

import UploadCvForm from '../../../../components/Forms/UploadCvForm/UploadCvForm.jsx'
import FormGlobalErrors from '../../../../components/Form/FormGlobalErrors.jsx'

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService'
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService'

import './Documents.scss'
import api from "../../../../../api.js"
import { format } from 'date-fns'
import {downloadFile} from "../../../../services/downloadService.js"
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx"
import Loader from "../../../../../shared/components/Loader/Loader.jsx"
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

export default class Documents extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      errors: null,
    }
  }
  onSubmitSuccess = async () => {
  }

  onUploadSuccess = async(cv) => {
    try {
      this.setState({ loading: true, errors: null })
      await this.props.submit({
        freelance: {
          ...prepareFreelanceBeforeSubmit(this.props.freelance),
          cv
        },
        user: prepareUserBeforeSubmit(this.props.user),
      })
    } catch(e) {
      console.warn(e)
      this.setState({ errors: e.errors })
    } finally {
      this.setState({ loading: false })
    }
  }

  onCvNormalizedDownloaded = async () => {
    this.setState({loading: true})
    this.downloadCvNormalized()
      .finally(() => {
        this.setState({loading: false})
      })
  }

  downloadCvNormalized = () => {
    return api.freelances.cv.getNormalized({
      freelance: this.props.freelance.id,
      anonymized: false
    })
      .then((blob) => {
        const firstname = this.props.user?.firstname ?? ''
        const freelanceId = this.props.freelance?.id ?? 0
        const dateFormatted = format(new Date(), 'yyyyMMdd')
        const name = `${dateFormatted}-CV_Twineeds-${firstname}-${freelanceId}`
        return downloadFile(blob, name, 'pdf')
      })
      .catch((err) => console.warn(err))
  }

  render() {
    const {user, freelance} = this.props

    return (
      <FreelancePage className="step-upload-cv p-5">
        <Loader visible={!!this.state.loading}>Téléchargement du DC ...</Loader>
        <h2 className="text-center">Mon CV</h2>

        <FormGlobalErrors errors={this.state.errors}/>

        <UploadCvForm
          className="upload-container"
          onSubmitSuccess={this.onSubmitSuccess}
          onUploadSuccess={this.onUploadSuccess}
          cv={freelance?.cv ?? null}
          freelanceId={user?.freelance_id ?? 0}
          history={this.props.history}
          freelance={this.props.freelance}
          user={this.props.user}
          currentUser={this.props.currentUser}
        />

        <h2 className="text-center mt-5">Dossier de compétences</h2>

        <CardRow direction="column" justify="center" align="center" gap="20px">
          <CardCol>
            Récupérer mon dossier de compétences format Twineeds (PDF)
          </CardCol>
          <CardCol>
            <button className="btn btn-primary" onClick={this.onCvNormalizedDownloaded}>
              DC Français
            </button>
          </CardCol>
        </CardRow>
      </FreelancePage>
    )
  }
}
